module.exports = __webpack_public_path__ + "img/tree-fire-flame-03-a.a0c7851a.png";